export const PIE_CHART_DRILLDOWN_OPTIONS: Highcharts.Options = {
  chart: {
    type: "pie",
  },
  title: {
    text: "",
  },
  plotOptions: {
    pie: {
      allowPointSelect: true,
      cursor: "pointer",
      dataLabels: {
        enabled: true,
        format: "{point.tooltip}: {point.percentage:.1f}%",
      },
    },
  },
  series: [],
  drilldown: {
    series: [],
  },
  exporting: {
    enabled: true,
    fallbackToExportServer: true,
    buttons: {
      contextButton: {
        align: "right",
        verticalAlign: "top",
        y: -43,
        x: -30,
      },
    },
  },
  credits: {
    enabled: false,
  },
};
